export const timeout = {
  locationChangeTooltip: 5000,
  closePromoBanner: 7000,
  closePromoBannerCart: 12000,
  orderErrorNotification: 30000,
  minQtyNotification: 2000,
}
